import forDevice from '../../hoc/for-device';
import CommentMobile from './comment-mobile';
import CommentDesktop from './comment-desktop';
export const Comment = forDevice(CommentMobile, CommentDesktop);
export * from './comment-deleted';
//# sourceMappingURL=index.js.map